import styled from 'styled-components';

const StyledChatToggleButtonBubble = styled.div`
  border: 1px solid #B5B5B5;
  border-radius: 8px;
  padding: 18px;
  max-width: 300px;
  flex-shrink: 0;
  background-color: #fff;
`;

export default StyledChatToggleButtonBubble;